import { render, staticRenderFns } from "./my-module-dialog.vue?vue&type=template&id=300f128a&scoped=true"
import script from "./my-module-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./my-module-dialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./my-module-dialog.vue?vue&type=style&index=0&id=300f128a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300f128a",
  null
  
)

export default component.exports